import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import {
    createStyles,
    makeStyles,
    useTheme,
    Theme
} from '@material-ui/core/styles';
import { Drawer, Box, Badge } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { ApplicationState } from "../store";
import * as APIStore from "../store/APIStore";
import { connect, useSelector } from "react-redux";
import RequestAccessToken from '../util/authService';
import { DrawerBadge } from './DrawerBadge'
import { refMDLoaded, practiceCoordinatorLoaded, shouldTryRefMDProfile, shouldTryCareCoordinatorProfile } from './common/ProfileHelper'

{/* BEGIN WENDY ADDED EDITED */ }
import VitalsMDTheme from './VitalsMDTheme';
import './Drawer.css';
import { SvgIcon } from '@material-ui/core';
import { NotificationsNone, AccountCircle, PeopleOutlined, MenuOpen, BeachAccess, Storage, ExitToApp, AssessmentOutlined, LocalHospital } from '@material-ui/icons';
import navlogo from '../images/vitalsmd-portal-nav-logo.svg';
import squarelogo from '../images/vitalsmd-portal-square-logo.svg';
import Button from '@material-ui/core/Button';
import SettingsIcon from '@material-ui/icons/Settings';
import { Link, NavLink, useLocation } from 'react-router-dom';
import LogoutButton from './LogoutButton';

const drawerWidth = 240;

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
        },
        appBar: {
            zIndex: theme.zIndex.drawer + 1,
            transition: theme.transitions.create(['width', 'margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
        },
        appBarShift: {
            marginLeft: drawerWidth,
            width: `calc(100% - ${drawerWidth}px)`,
            transition: theme.transitions.create(['width', 'margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        menuButton: {
            marginRight: 36,
        },
        hide: {
            display: 'none',
        },
        drawer: {
            width: drawerWidth,
            flexShrink: 0,
            whiteSpace: 'nowrap',
        },
        drawerOpen: {
            width: drawerWidth,
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        drawerClose: {
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            overflowX: 'hidden',
            width: theme.spacing(7) + 1,
            [theme.breakpoints.up('sm')]: {
                width: theme.spacing(9) + 1,
            },
        },
        toolbar: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            padding: theme.spacing(0, 1),
            // necessary for content to be below app bar
            ...theme.mixins.toolbar,
        },
        content: {
            flexGrow: 1,
            padding: theme.spacing(3),
        },
        title: {
            flexGrow: 1,
            textAlign: 'center',
        },
    }),
);


const MiniDrawer = (props: any) => {
    const classes = useStyles();
    const theme = useTheme();
    const [open, setOpen] = React.useState(true);
    let [tokenState, setTokenState] = useState<APIStore.TokenType | null>(null);

    let {
        getUnreadMessageCount,
        NotificationCount } = props;

    let { isLoading, isLoaded } = NotificationCount

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };
    const pathname = useLocation().pathname;
    let friendlyPath = pathname.replace("/", "").replaceAll("-", " ").split("/")[0];
    if (friendlyPath.includes("account"))
        friendlyPath = "account";
    if (friendlyPath.includes("patient list"))
        friendlyPath = "patient list";
    if (friendlyPath.includes("compose new message"))
        friendlyPath = "compose new message";
    const { children } = props;

    let tokenStatePr = RequestAccessToken()
        .then((token) => {
            if (token && !tokenState) {
                setTokenState(token);
            }
        });

    useEffect(() => {
        if (tokenState?.accessToken) {
            if (tokenState?.accessToken) {
                getUnreadMessageCount(tokenState.accessToken);
            }
        }
    }, [tokenState])

    return (
        <div className={classes.root}>
            <CssBaseline />
            <AppBar
                position="fixed"
                className={clsx(classes.appBar, {
                    [classes.appBarShift]: open,
                })}
            >
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        edge="start"
                        className={clsx(classes.menuButton, {
                            [classes.hide]: open,
                        })}
                    >
                        {/* Collapsed Logo */}
                        <img src={squarelogo} alt="Logo" tag={Link} to="/home" />

                        <MenuIcon />

                    </IconButton>
                    <Typography variant="h6" noWrap className={classes.title}>
                        <span className="page-title">
                            {friendlyPath}
                        </span>
                    </Typography>
                    <LogoutButton />
                </Toolbar>
            </AppBar>


            <Drawer
                //position="static"
                variant="permanent"
                className={clsx(classes.drawer, {
                    [classes.drawerOpen]: open,
                    [classes.drawerClose]: !open,
                })}

                classes={{
                    paper: clsx({
                        [classes.drawerOpen]: open,
                        [classes.drawerClose]: !open,
                    }),
                }}
            >
                <div className={classes.toolbar}>
                    <IconButton onClick={handleDrawerClose}>

                        {/* Expanded Logo */}
                        <img src={navlogo} alt="Logo" tag={Link} to="/home" />
                        <MenuOpen />
                    </IconButton>
                </div>

                <Divider />

                <List>
                    <ListItem
                        button
                        key="Dashboard"
                        component={NavLink} to="/dashboard"
                        activeClassName="Mui-selected" exact
                    >
                        <ListItemIcon>
                            <AssessmentOutlined />
                        </ListItemIcon>
                        <ListItemText primary="Dashboard" />
                    </ListItem>
                    <ListItem
                        button
                        key="Patient List"
                        component={NavLink} to="/patient-list-practice"
                        activeClassName="Mui-selected" exact
                    >
                        <ListItemIcon>
                            <PeopleOutlined />
                        </ListItemIcon>
                        <ListItemText primary="Patients" />
                    </ListItem>


                    <ListItem
                        button
                        key="Notifications"
                        component={NavLink} to="/notifications"
                        activeClassName="Mui-selected" exact
                    >
                        <ListItemIcon>
                            <DrawerBadge notificationState={NotificationCount} />
                        </ListItemIcon>

                        <ListItemText primary="Notifications" />
                    </ListItem>
                    <ListItem
                        button
                        key="DirectAdmit"
                        component={NavLink} to="/direct-admit-request"
                        activeClassName="Mui-selected" exact
                    >
                        <ListItemIcon>
                            <LocalHospital />
                        </ListItemIcon>
                        <ListItemText primary="Direct&nbsp;Admit" />
                    </ListItem>
                    <ListItem
                        button
                        key="Account"
                        component={NavLink} to="/account"
                        activeClassName="Mui-selected" exact
                    >
                        <ListItemIcon>
                            <AccountCircle />
                        </ListItemIcon>
                        <ListItemText primary="Account" />
                    </ListItem>

                </List>

            </Drawer>

            <main className={classes.content}>
                <div className={classes.toolbar} />
                {children}
            </main>

        </div>
    );
}

export default connect(
    (state: ApplicationState) => state.vitalsContext,
    APIStore.actionCreators
)(MiniDrawer as any);
